export const aboutTestimonials = [
  {
    name: "Emma McKell",
    comment:
      "I know he's my husband but being able to get 2 acres of sod delivered and installed within days was amazing. The trailer was perfect for the job and the service was top-notch.",
    rating: 5,
  },
  
];
